<template>
  <section class="content">
    <div class="modal show" tabindex="-1" role="dialog" ref="formComment" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ ticketTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-0">

            <form role="form">
              <div>
                <h3>KODE #{{ code }}</h3>
                <p>Catatan : {{ catatan }}</p>
              </div>
              <div class="alert alert-success" v-if="ticketStatus == 2">{{ updatedBy }} on {{ updatedOn }}</div>
              <div class="alert"
                v-bind:class="{ 'alert-claim-2 text-dark': returnClaim == '2', 'alert-claim-3': returnClaim == '3' }"
                v-if="returnClaim">
                Note :
                <span v-if="returnClaim == 1">Paket Diclaim</span>
                <span v-else-if="returnClaim == 2">Claim disetujui</span>
                <span v-else-if="returnClaim == 3">Claim ditolak</span>
                {{ return_claim_done }}
              </div>
            </form>
          </div>
          <div class="direct-chat-messages" style="height: auto">
            <!-- Message. Default to the left -->
            <div class="direct-chat-msg" v-for="comment in comments">
              <div class="direct-chat-infos d-flex justify-content-between" :class="{ 'flex-row-reverse' : comment.claim }">
                <span class="direct-chat-name">{{
                    comment.who
                }}</span>
                <span class="direct-chat-timestamp">{{
                    comment.time
                }}</span>
              </div>

              <div v-if="comment">
                <!-- /.direct-chat-img -->
                <div :class="( comment.message.split(' ')[1] == 'DiBanding' || comment.message.split(' ')[1] == 'Pending' ? 'direct-chat-info' : comment.message.split(' ')[1] == 'DiTolak' ? 'direct-chat-red' : comment.message.split(' ')[1] == 'DiSetujui' ? 'direct-chat-teal' : comment.message.split(' ')[1] == 'reject' ? 'direct-chat-maroon' : comment.message.split(' ')[1] == 'approve' ? 'direct-chat-olive' : 'direct-chat-primary' )">
                  <div class="right">
                    <div class="direct-chat-text w-fit mx-0" :class="( comment.claim ? 'ml-auto' : 'd-none' )">
                      {{ comment.message }}
                    </div>
                  </div>
                  <div class="direct-chat-text w-fit mx-0" :class="( comment.claim ? 'd-none' : 'mr-auto' )">
                    {{ comment.message }}
                  </div>
                </div>
              </div>
              <ul style="padding-left: 0">
                <li v-for="file in comment.attachments" style="list-style: none;display: inline-block;margin-right: 5px;">
                  <a style="cursor: pointer" @click="openImg(file)"><i class="fa fa-paperclip"></i> {{ file.name }}</a>
                </li>
              </ul>
              <!-- /.direct-chat-text -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false" :showThumbs="false"
      :showFooterCount="false">
    </LightBox>
  </section>
</template>
<script>
import { authFetch, charsRemover } from "@/libs/hxcore";
import $ from "jquery";
import LightBox from "vue-image-lightbox";

import vSelect from "vue-select";
import maskedInput from "vue-masked-input";
import { CurrencyInput } from "vue-currency-input";
import "vue-select/dist/vue-select.css";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
export default {
  name: "ArsipTicketComment",
  props: { show: Boolean, value: Object, orderId: String },
  data() {
    return {
      ticketTitle: "Lihat Ticket",
      errors: [],
      categories: [],
      priorityOpt: [],
      comments: [],
      method: "POST",
      selectedId: 0,
      defaultId: 1,
      addrOptions: [],
      addrJne: [],
      courierBranchOption: [],
      formTitle: "Buat Tiket",
      files: [],
      loaded: false,
      code: "",
      catatan: "",
      ticketStatus: '',
      form: {
        //to create pickup address
        id: "",
        message: "",
        attachments: "",
        refcode: "",
      },
      imgshow: true,
      media: [
        {
          // For image
          thumb: "",
          src: "",
          caption: "",
        },
      ],
      returnClaim: "",
    };
  },
  components: {
    vSelect,
    maskedInput,
    LightBox,
  },
  created() { },
  methods: {
    openImg: function (file) {
      var attr = {
        thumb: file.link,
        src: file.link,
        caption: file.name,
      };
      this.media = [attr];
      this.$refs.lightbox.showImage(0);
      return false;
    },
    loadTicket: function (id) {
      authFetch("/ticket/arsip_order/" + id).then((res) => {
        res.json().then((json) => {
          if (json.success) {
            this.ticketTitle = json.data.title;
            this.comments = json.comments;
            this.form.id = json.data.id;
            this.code = json.data.no_resi;
            this.catatan = json.data.catatan;
            this.ticketStatus = json.data.status;
            this.updatedBy = json.data.updatedBy;
            this.updatedOn = json.data.updatedOn;
            this.returnClaim = json.data.return_claim;
            this.claim = json.comments.claim;
            this.return_claim_done = json.data.return_claim_done;
            //this.categories = json.data;
          }
        });
      });
    },
  },
  mounted() {
    // console.log("warehouse1", this.value);
    const e = this.$refs;
    // if (this.show === true) $(e.formSelectPickup).modal("show");
    // console.log(this.show);         
    $(e.formComment).on("show.bs.modal", (e) => {
      //if (!this.loaded) {
      this.loaded = true;
      this.loadTicket(this.orderId);
      //this.$root.$emit("reloadDashboardTicket");
      //}
    });
  },
  watch: {
    show: function (old, val) {
      $(this.$refs.formComment).modal("show");
    },
    orderId: function (old, val) {
      this.form.refcode = this.orderId;
    },
    value: function (old, val) { },
    form: {
      handler(val) {
        this.form.message = charsRemover(val.message);
      },
      deep: true
    },
  },
};
</script>
<style scoped>
.alert-claim-2 {
  color: #ffffff;
  background: #66ff33;
  border-color: #60F030;
}

.alert-claim-3 {
  color: #ffffff;
  background: #ff582e;
  border-color: #F0542B;
}

.direct-chat-teal > .direct-chat-text {
  background: #00AB4F;
  border-color: #00AB4F;
  color: #ffffff;
}

.direct-chat-teal > .direct-chat-text::after, .direct-chat-teal > .direct-chat-text::before {
  border-right-color: #00AB4F;
}

.direct-chat-olive > .direct-chat-text {
  background: #007837;
  border-color: #007837;
  color: #ffffff;
}

.direct-chat-olive > .direct-chat-text::after, .direct-chat-olive > .direct-chat-text::before {
  border-right-color: #007837;
}

.direct-chat-red > .direct-chat-text {
  background: #D60F0F;
  border-color: #D60F0F;
  color: #ffffff;
}

.direct-chat-red > .direct-chat-text::after, .direct-chat-red > .direct-chat-text::before {
  border-right-color: #D60F0F;
}

.direct-chat-maroon > .direct-chat-text {
  background: #8E1F29;
  border-color: #8E1F29;
  color: #ffffff;
}

.direct-chat-maroon > .direct-chat-text::after, .direct-chat-maroon > .direct-chat-text::before {
  border-right-color: #8E1F29;
}
</style>